if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelector("variant-radios");
        this.submitButton = this.querySelector('[type="submit"]');
        this.loyaltyPoints = this.querySelector(".js-loyalty-points");

        this.addEventListener("update-loyalty", () => {
          this.updateLoyaltyPoints();
        });

        this.preventRechargeMutation();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      preventRechargeMutation() {
        const priceContainer = this.querySelector('.product__buy-area-price');
        const initialPrice = priceContainer.querySelector('[data-initial-price]').dataset.initialPrice;
        const priceElement = priceContainer.querySelector('.price-item--regular');
        let initialReset = false;

        const removeDummyClass = () => {
          priceContainer.classList.remove('product__buy-area-price--dummy-price');
        }
      
        const resetPrice = () => {
          priceElement.textContent = initialPrice;
          initialReset = true;
          removeDummyClass();
        }

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-price-mutation-watcher') {
              priceContainer.removeAttribute('data-price-mutation-watcher');
              if (!initialReset) resetPrice();
            }
          });
        });
      
        const config = { attributes: true };
        observer.observe(priceContainer, config);
      
        if (priceContainer.hasAttribute('data-price-mutation-watcher')) {
          priceContainer.removeAttribute('data-price-mutation-watcher');
          if (!initialReset) resetPrice();
        }

        // Remove dummy class after if recharge mutation is not triggered
        setTimeout(() => {
          removeDummyClass();
        }, 3000);
      }

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
            this.updateLoyaltyPoints();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      updateLoyaltyPoints() {
        const productPrice = this.querySelector(
          ".product__buy-area-price .price"
        ).classList.contains("price--on-sale")
          ? this.querySelector(
              ".product__buy-area-price .price .price__sale .price-item--sale"
            ).innerHTML
          : this.querySelector(
              ".product__buy-area-price .price .price__regular .price-item--regular"
            ).innerHTML;

        const quantity =
          this.querySelector('input[name="quantity"]').value || 1;

        if (productPrice) {
          this.loyaltyPoints.innerHTML = Math.floor(
            parseFloat(productPrice.replace(/[^0-9\.-]+/g, "")) * quantity
          );
        }

        this.updatePrices();
      }

      updatePrices() {
        // Visually multiply price by quantity
        const formPrices = this.querySelectorAll(".product__buy-area-price .price-item");
        const quantity = this.input.value || 1;

        const updatePrice = (multiplier, priceElement) => {   
          if (!priceElement.dataset.price) priceElement.dataset.price = priceElement.textContent;       
          const priceText = priceElement.dataset.price.trim();
          const currencySymbol = priceText.match(/^[^\d]+/)?.[0] || '';
          if (!currencySymbol) return;
          const cleanedPrice = priceText
                                  .replace(/^[^\d,.-]+/, '')  // Remove leading currency symbol
                                  .replace(/[^\d,.-]/g, '')   // Remove any remaining non-numeric characters
                                  .replace(',', '.');         // Convert comma to decimal point
          const numericValue = parseFloat(cleanedPrice);
          const newPrice = (numericValue * multiplier).toFixed(2);
          priceElement.textContent = currencySymbol + newPrice;
        }

        formPrices.forEach((priceElement) => {
          updatePrice(quantity, priceElement);
        });
      }
    }
  );
}
